exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Popover .Popover-body{background-color:#ededed;border-radius:5px;padding:10px;font-weight:100;font-family:ProximaNova,arial,sans-serif}.Popover .Popover-tip{fill:#ededed}.Popover.failure .Popover-body{background-color:#ff553d;color:#fff}.Popover.failure .Popover-tip{fill:#ff553d}", ""]);

// exports
